<template>
    <div class="row d-flex">
        <div class="col-auto my-auto">
            Filter:
        </div>
        <div class="col-auto">
            <input-group icon="fas fa-filter" :append="canClear">
                
                <input class="form-control" type="text" v-model="value" ref="input" @keyup.esc="clear">
                
                <template v-slot:append>
                    <button class="btn btn-outline-danger" title="Clear filters" data-toggle="tooltip" @click="clear">
                        <i class="fas fa-times"></i>
                    </button>
                </template>

            </input-group>
        </div>
    </div>
</template>

<script>

//Mixins
import resources from '../../../Util/Mixins/resources';
import tooltips from '../../../Util/Mixins/tooltips';

//Components
import InputGroup from '../../Inputs/InputGroup.vue';

export default {
    name: 'data-table-filter',
    mixins: [resources, tooltips],
    components: {
        InputGroup
    },
    methods: {
        clear() {
            this.value = '';
            this.focus();
        },
        focus() {
            this.$refs.input.focus();
        }
    },
    watch: {
        value(value) {
            this.$emit('filter', value);
        },
        //Hard remove tooltips when clear button is disabled.
        //Otherwise tooltip will linger.
        canClear(value) {
            if(!value) {
                var elements = document.getElementsByClassName('tooltip');

                for (let element of elements) {
                   element.parentNode.removeChild(element);
                }
            }
        }
    },
    computed: {
        canClear() {
            return this.value !== '';
        }
    },
    data() {
        return {
            value: ''
        };
    }
};
</script>